export const getDecimalPoint = (itemName, allCurrencies) => {
    const item = allCurrencies.filter(item => item.name == itemName)[0]
    if (item?.decimal) return item.decimal
    return 5
}